/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomUserPersonListItemViewModel } from "../types/ClassroomUserPersonListItemViewModel.ts";

export const classroomUserPersonListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  personId: z.optional(z.number().int()),
  personName: z.string().nullish(),
  classroomDisciplineId: z.optional(z.number().int()),
}) as unknown as ToZod<ClassroomUserPersonListItemViewModel>;
